<template>
  <div>
    <div class="content-header">
      <div class="left">
        <span class="title">项目管理</span>
      </div>
      <div class="right">
        <Button type="primary" icon="md-add" @click="showModal(true)"
          >新增项目</Button
        >
      </div>
    </div>
    <div class="tips" style="margin-bottom: 20px">
      <Icon
        type="md-alert"
        size="20"
        color="#2d8cf0"
        style="margin-right: 10px"
      />
      <div>
        说明：可为企业新建正在进行或即将开展的项目，并将项目的参与员工与项目进行关联，作业时数据将归属于某项目，方便按项目进行费用成本核算
      </div>
    </div>

    <div class="filter-box">
      <div class="bottom" style="margin-top: 0px">
        <span class="subtitle">自定查找:</span>
        <Input
          style="width: 200px; margin-left: 6px; margin-right: 10px"
          placeholder="关键字查找"
          v-model="page.key"
        />
        <span class="btn-filter" @click="getData">查询</span>
        <span class="btn" @click="reset">清空</span>
        <Poptip title="导出Excel" placement="right" trigger="hover">
          <span class="btn">导出报表</span>
          <div slot="content">
            <Button
              type="primary"
              style="margin-right: 5px"
              @click="exportData(0)"
              >导出当前页</Button
            >
            <Button type="success" @click="exportData(1)">导出所有页</Button>
          </div>
        </Poptip>
      </div>
    </div>

    <Table :data="data" :columns="columns" />
    <div class="t-right">
      <Page
        @on-change="pageChange"
        @on-page-size-change="staffSizeChange"
        :total="total"
        show-elevator
        show-sizer
        show-total
      />
    </div>

    <Modal v-model="modal.visible" :width="900" :title="modal.title">
      <Form
        :label-width="100"
        :model="modal.data"
        :rules="ruleValidate"
        ref="formValidate"
      >
        <FormItem prop="name" label="项目名称:">
          <Input
            v-model="modal.data.name"
            style="width: 260px"
            placeholder="请输入项目名称"
          />
        </FormItem>
        <FormItem prop="person" label="负责人:">
          <Input
            v-model="modal.data.person"
            style="width: 260px"
            placeholder="请输入负责人"
          />
        </FormItem>
        <FormItem prop="des" label="项目描述:">
          <Input
            v-model="modal.data.des"
            style="width: 260px"
            :rows="4"
            placeholder="请输入项目描述"
            type="textarea"
          />
        </FormItem>
        <FormItem prop="describe" label="参与员工:">
          <Button type="primary" @click="selectStaff">选择员工</Button>
        </FormItem>
        <div style="padding: 0 30px">
          <Table :data="staffData" :columns="staffColumns" />
        </div>
      </Form>
      <div slot="footer">
        <Button type="text" @click="modal.visible = false">取消</Button>
        <Button type="primary" v-preventReClick @click="modalOk">确定</Button>
      </div>
    </Modal>
    <Modal v-model="staffModal.visible" :width="920" title="选择员工">
      <div>
        <div style="margin-bottom: 10px">
          <Input
            v-model="staffPage.keyword"
            placeholder="关键字搜索"
            style="width: 280px"
          >
          </Input>
          <Button
            style="margin: 0 10px"
            type="primary"
            v-preventReClick
            @click="filterStaff"
            >查询</Button
          >
          <Button @click="resetStaff">清空</Button>
        </div>
        <Table
          :data="staffModal.data"
          :columns="staffColumns2"
          @on-selection-change="selectTable"
        />
        <div class="t-right">
          <Page
            @on-change="staffPageChange"
            @on-page-size-change="staffSizeChange"
            :total="staffModal.total"
            show-elevator
            show-sizer
            show-total
          />
        </div>
      </div>
      <div slot="footer">
        <Button type="text" @click="staffModal.visible = false">取消</Button>
        <Button type="primary" v-preventReClick @click="modalStaffOk"
          >确定</Button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import excel from "@/libs/excel";
export default {
  data() {
    this.staff_is_del = {
      "-1": { text: "待审核", color: "#ff9900" },
      0: { text: "正常", color: "#19be6b" },
      1: { text: "禁用", color: "#ed4014" },
    };
    return {
      type: "staff",
      data: [],
      columns: [
        { key: "id", title: "项目编号", show: true },
        { key: "name", title: "项目名称", show: true },
        { key: "des", title: "项目描述", show: true },
        { key: "person", title: "负责人", show: true },
        {
          key: "create_time",
          title: "新建日期",
          show: true,
          render: (h, data) => {
            return h("span", this.$moment(data.row.create_time));
          },
        },
        {
          key: "status",
          title: "状态",
          show: true,
          render: (h, data) => {
            return h(
              "span",
              data.row.status == 0
                ? "创建"
                : data.row.status == 1
                ? "正常"
                : "完成"
            );
          },
        },
        { key: "staff_num", title: " 成员数", show: true },
        {
          key: "operate",
          title: "操作",
          width: 200,
          render: (h, data) => {
            let temp = [
              h(
                "Button",
                {
                  props: {
                    type: `${
                      data.row.status == 0 || data.row.status == 2
                        ? "success"
                        : "warning"
                    }`,
                    size: "small",
                  },
                  on: {
                    click: () => {
                      let param = data.row;
                      if (param.status == 0 || param.status == 2) {
                        param.status = 1;
                      } else {
                        param.status = 2;
                      }
                      this.saveProject(param);
                    },
                  },
                },
                `${
                  data.row.status == 0 || data.row.status == 2 ? "启用" : "禁用"
                }`
              ),
              h(
                "Button",
                {
                  props: { type: "primary", size: "small" },
                  style: { marginLeft: "5px" },
                  on: {
                    click: () => {
                      this.modal.data = data.row;
                      this.showModal();
                    },
                  },
                },
                "编辑"
              ),
              h(
                "Button",
                {
                  props: { type: "error", size: "small" },
                  style: { marginLeft: "5px" },
                  on: {
                    click: () => {
                      if (data.row.status == 1) {
                        this.$Modal.warning({
                          title: "重要提醒",
                          content: "状态为正常时，不能删除",
                        });
                      } else {
                        this.$Modal.confirm({
                          title: "重要提醒",
                          content: "确认删除该项目吗？",
                          onOk: () => {
                            let params = {
                              is_del: 1,
                              id: data.row.id,
                            };
                            this.saveProject(params);
                          },
                        });
                      }
                    },
                  },
                },
                "删除"
              ),
            ];
            return temp;
          },
        },
      ],
      total: 0,
      page: {
        p: 0,
        l: 10,
        key: "",
      },
      date: [],
      modal: {
        visible: false,
        title: "新增项目",
        data: {
          name: "",
          principal: "",
          describe: "",
        },
      },
      ruleValidate: {
        name: [{ required: true, message: "请输入项目名称", trigger: "blur" }],
        person: [{ required: true, message: "请输入负责人", trigger: "blur" }],
        des: [{ required: true, message: "请输入项目描述", trigger: "blur" }],
      },
      staffData: [],
      staffSelectData: [],
      staffColumns: [
        {
          key: "staff_name",
          title: "姓名",
          show: true,
        },
        {
          key: "staff_account",
          title: "员工账号",
          show: true,
        },
        { key: "department_name", title: "部门", show: true },
        {
          key: "operate",
          title: "操作",
          width: 110,
          render: (h, data) => {
            return h(
              "div",
              {
                on: {
                  click: () => {
                    if (data.row.id) {
                      this.delete(this.modal.data.id, data.row.staff_id);
                    } else {
                      let i, j;
                      this.staffData.map((item, index) => {
                        if (item.id == data.row.id) {
                          i = index;
                        }
                      });
                      this.staffData.splice(i, 1);
                      this.staffSelectData.map((item, index) => {
                        if (item.id == data.row.staff_id) {
                          j = index;
                        }
                      });
                      this.staffSelectData.splice(j, 1);
                    }
                  },
                },
              },
              [
                h(
                  "span",
                  {
                    style: {
                      color: "#ed4014",
                      marginLeft: "5px",
                      cursor: "pointer",
                    },
                  },
                  "删除"
                ),
              ]
            );
          },
          show: false,
        },
      ],
      staffColumns2: [
        {
          type: "selection",
          width: 60,
          align: "center",
        },
        {
          key: "name",
          title: "姓名",
          show: true,
          render: (h, data) => {
            let temp = [h("span", data.row.name)];
            if (data.row.is_admin) {
              temp.push(
                h("i", {
                  class: "ivu-icon ivu-icon-ios-person",
                  style: { fontSize: "16px", color: "#2d8cf0" },
                })
              );
            }
            return temp;
          },
        },
        {
          key: "tel",
          title: "员工账号",
          show: true,
        },
        { key: "department_name", title: "部门", show: true },
      ],
      staffPage: {
        p: 0,
        l: 10,
        keyword: "",
      },
      staffModal: {
        visible: false,
        data: [],
      },
    };
  },
  methods: {
    staffSizeChange(l) {
      this.page.l = l;
      this.getData();
    },
    pageChange(p) {
      this.page.p = p - 1;
      this.getData();
    },
    getData() {
      this.GetProject(this.page).then((res) => {
        this.data = res.data;
        this.total = res.total;
      });
    },

    deleteRechargeLog(id) {
      this.DeleteRechargeLog({ id }).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        res.status && this.getData();
      });
    },
    //显示项目信息弹窗
    showModal(isAdd) {
      this.modal.visible = true;
      this.modal.title = isAdd ? "新增项目" : "编辑项目";

      if (isAdd) {
        this.modal.data = {
          name: "",
          principal: "",
          describe: "",
        };
        this.staffData = [];
      } else {
        let project_id = this.modal.data.id;
        this.GetProjectStaff({ project_id }).then((res) => {
          this.staffData = res.data;
        });
      }
    },
    modalOk() {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.saveProject(this.modal.data);
        } else {
          this.$Message.error("Fail!");
        }
      });
    },
    modalCancel() {
      this.modal.visible = false;
      this.$refs.formValidate.resetFields();
    },
    saveProject(data) {
      if (data.name && data.name.length > 30) {
        this.$Message.error("项目名称不能超过30个字符!");
        return;
      }
      this.SaveProject(data).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        this.modal.visible = false;
        if (data.is_del) {
          this.getData();
        }
        //添加项目成员
        if (this.staffSelectData.length > 0) {
          let ids = [];
          this.staffSelectData.map((item) => {
            ids.push(item.id);
          });
          let param = {
            project_id: data.id ? data.id : res.data.project_id,
            staff_ids: ids.join(","),
          };
          this.SaveProjectStaff(param).then((result) => {
            this.staffSelectData = [];
            this.getData();
          });
        }
      });
    },
    delete(project_id, staff_id) {
      this.DeleteProjectStaff({
        project_id,
        staff_id,
      }).then((res) => {
        this.$Message[res.status ? "success" : "error"](res.msg);
        this.GetProjectStaff({ project_id }).then((res) => {
          this.staffData = res.data;
        });
      });
    },
    reset() {
      this.page = {
        p: 0,
        l: 10,
        type: 0,
        start: "",
        end: "",
        search: "",
      };
      this.date = [];
      this.getData();
    },
    exportData(is_all) {
      let title = [],
        key = [],
        columns = this.columns;
      columns.map((item) => {
        if (item.show) {
          let itemKey = item.key;
          title.push(item.title);
          key.push(itemKey);
        }
      });
      let params = {
        title: title,
        key: key,
        autoWidth: true,
        filename: "项目管理",
      };
      if (is_all) {
        this.GetProject({
          p: 0,
          l: 10000,
          key: this.page.key,
        }).then((res) => {
          params.data = this.excelData(res.data);
          excel.export_array_to_excel(params);
        });
      } else {
        params.data = this.excelData(this.data);
        excel.export_array_to_excel(params);
      }
    },
    excelData(data) {
      let result = JSON.parse(JSON.stringify(data));
      result.map((item) => {
        item.create_time = this.$moment(item.create_time);
        item.status =
          item.status == 0 ? "创建" : item.status == 1 ? "正常" : "完成";
      });
      return result;
    },
    selectStaff() {
      this.staffModal.visible = true;
      this.staffPage = {
        p: 0,
        l: 10,
        keyword: "",
      };
      this.GetStaff(this.staffPage).then((res) => {
        this.staffModal.data = res.data;
        this.staffModal.total = res.total;
      });
    },
    filterStaff() {
      this.GetStaff(this.staffPage).then((res) => {
        this.staffModal.data = res.data;
        this.staffModal.total = res.total;
      });
    },
    selectTable(selection) {
      this.staffSelectData = selection;
    },
    modalStaffOk() {
      this.staffModal.visible = false;
      const result = this.staffSelectData.map((item) => ({
        staff_id: item.id,
        staff_name: item.name,
        staff_account: item.tel,
        department_name: item.department_name,
        create_time: item.create_time,
        is_del: item.is_del,
      }));
      if (this.staffData.length > 0) {
        let json = this.staffData.concat(result);
        let newJson = [];
        for (const item1 of json) {
          let flag = true;
          for (const item2 of newJson) {
            if (item1.staff_id == item2.staff_id) {
              flag = false;
            }
          }
          if (flag) {
            //判断是否重复
            newJson.push(item1);
          }
        }
        this.staffData = newJson;
      } else this.staffData = result;
    },
    staffSizeChange(l) {
      this.staffPage.l = l;
      this.filterStaff();
    },
    staffPageChange(p) {
      this.staffPage.p = p - 1;
      this.filterStaff();
    },
    resetStaff() {
      this.staffPage = {
        p: 0,
        l: 10,
        is_del: 0,
        search: "",
      };
      this.selectStaff();
    },
    ...mapActions([
      "GetProject",
      "SaveProject",
      "GetProjectStaff",
      "SaveProjectStaff",
      "DeleteProjectStaff",
      "GetStaff",
    ]),
  },
  mounted() {
    this.getData();
  },
  computed: mapGetters({
    company: "company",
  }),
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
